import * as React from 'react'
import { LogoLemanaPro } from 'fronton-react'
import styled from 'styled-components'
import { HeaderTabMenu } from './HeaderTabMenu'
import { UserBlock } from 'shared/components/UserBlock'
import type { UserInfoResponse } from 'redux/interfaces'
import { PLACEHOLDER, ROOT } from 'shared/consts'
import { Link } from 'react-router-dom'

const StyledHeader = styled.header`
    width: 100%;
`

const Top = styled.div`
    height: 90px;
    {
        /* background: ${({ theme }) => `${theme.mainDarkColor}`}; */
    }
    background-color: #fdc300;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const HeaderLogo = styled.div`
    margin: 0 10px;
    transition: background-color ease-in-out 0.2s;
    width: 110px;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px;

    &:hover {
        background-color: ${({ theme }) => theme.mainColor};
        cursor: pointer;
    }
`

const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 10px 20px;
`

const HeaderTitle = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #21282b;
    font-size: 16px;
    font-weight: bold;
`
const HeaderUser = styled.div`
    display: flex;
    align-items: center;
    margin: 0 10px;
`

const UserName = styled.span`
    display: flex;
    flex-direction: column;
    text-align: end;
    color: #21282b;
    padding-right: 10px;
    font-weight: bold;
`

interface IHeader {
    title?: string
    userInfo: UserInfoResponse
}

export class Header extends React.PureComponent<IHeader> {
    public static displayName = 'Header'
    public static TabMenu = HeaderTabMenu

    // public static Action = HeaderAction

    render() {
        const { userInfo } = this.props
        // let tabMenuElement: JSX.Element | null = null
        // let actionElement: JSX.Element | null = null

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // React.Children.map(children, (child: any) => {
        //     if (child && child.type) {
        //         switch (child.type.displayName) {
        //             case HeaderTabMenu.displayName:
        //                 tabMenuElement = child
        //                 break
        //             case HeaderAction.displayName:
        //                 actionElement = child
        //                 break
        //         }
        //     }
        // })

        return (
            <StyledHeader>
                <Top>
                    <HeaderLogo>
                        <Link to={ROOT}>
                            <LogoLemanaPro invert={false} variant="monochrome" type="line" />
                        </Link>
                    </HeaderLogo>
                    <HeaderContent>
                        <HeaderTitle>Календарь недоступности поставщиков</HeaderTitle>
                        <HeaderUser>
                            <UserName>
                                <span>
                                    Отделение поставщика{' '}
                                    {localStorage.getItem('supplierId') || PLACEHOLDER}
                                </span>
                                {userInfo.subtitle && <span>{userInfo.subtitle}</span>}
                            </UserName>
                            <UserBlock />
                        </HeaderUser>
                    </HeaderContent>
                </Top>
            </StyledHeader>
        )
    }
}
